import React, { Component } from 'react'
import Modal from 'react-modal'
import CacheKeys from '../../../../cache/CacheKeys'
import CacheManager from '../../../../cache/CacheManager'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import RemarksModalUI from './RemarksModalUI.js'

class RemarksModalSF extends Component {
    constructor(props) {
      super(props)
      this.state = {
        successMsg: null,
        errorList: null,
        submitted: false,
        remarks: this.props.selectedRemarks || '',
        remarksError: null,
      }
    }

    render() {
      return (
        <RemarksModalUI
          context={this.props.context}
          account={this.props.account}
          errorList={this.state.errorList}
          successMsg={this.state.successMsg}
          setErrorList={this.setErrorList}
          // modes
          updateMode={this.props.updateMode}
          submitted={this.state.submitted}
          // event handlers
          onSubmit={this.onSubmit}
          onCancelClick={this.onCancelClick}
          // form fields
          remarks={this.state.remarks}
          onRemarksChange={(event) => { this.setState({ remarks: event.target.value})}}
          remarksError={this.state.remarksError}
          setRemarksError={(error) => { this.setState({ remarksError: error }) }}
        />
      )
    }

    componentDidMount() {
      let context = this.props.context
      Modal.setAppElement('body')
    }

    componentDidUpdate(prevProps) {
      // console.log(this.props)
      if (prevProps.selectedRemarks != this.props.selectedRemarks)
        this.setState({remarks: this.props.selectedRemarks})
    }

    onSubmit = () => {
      let submitted = this.state.submitted
      if (submitted)
        return

      this.setState({
        successMsg: null,
        errorList: [],
        submitted: true
      })

      RestApiUtils.post(this.props.context,
        `/api/su/accounts/${this.props.account.accountId}/objectCode/${this.props.objectCode}/objectId/${this.props.objectId}/remarks`,
        this.onSubmitCallback, {
          remarks: this.state.remarks,
        }
      )
    }

    onSubmitCallback = (response) => {
      let errorList = []
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })

      this.setState({
        successMsg: response.success,
        errorList: errorList,
        submitted: false
      })

      if (response.errorList.length === 0) {
        this.props.onRefreshClick("noBusy")

        setTimeout(() => {
          this.setState({
            successMsg: null
          })
          this.props.onCancelClick()
        }, 1000)
      }
    }

    onCancelClick = () => {
      this.setState({
        errorList: null,
        submitted: false,
      })
      this.props.onCancelClick()
    }

    setErrorList = (errorList) => {
      this.setState({errorList: errorList})
    }
  }

  export default RemarksModalSF
